import { render } from "./Ethereum.vue?vue&type=template&id=4aaa803e"
import script from "./Ethereum.vue?vue&type=script&lang=js"
export * from "./Ethereum.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__